import { subjectTheme } from "@/lib/subjects";

export const TYPE_META = {
  class: { label: "Class", hex: "#4B2BB8", soft: "#F3F0FF" },
  mock: { label: "Mock exam", hex: "#E11D48", soft: "#FFF1F2" },
  key_date: { label: "Key exam date", hex: "#D97706", soft: "#FFFBEB" },
  deadline: { label: "Homework due", hex: "#4B2BB8", soft: "#F3F0FF" },
  other: { label: "Event", hex: "#475569", soft: "#F1F5F9" },
};

export const PROGRAM_LABELS = { jmss: "JMSS Year 10", selective: "Year 9 Selective", general: "General Year 10" };

export function eventColor(ev) {
  if (ev.type === "class") {
    const t = subjectTheme(ev.subject || "", ev.title || "");
    return { hex: t.hex, soft: t.softHex };
  }
  return TYPE_META[ev.type] || TYPE_META.other;
}

const pad = (n) => String(n).padStart(2, "0");
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayMelb = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Australia/Melbourne" }).format(new Date());
export const addDays = (ds, n) => { const d = new Date(`${ds}T00:00:00`); d.setDate(d.getDate() + n); return iso(d); };

export function monthGrid(year, month) {
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  return Array.from({ length: 42 }, (_, i) => new Date(year, month, 1 - offset + i));
}

export function fmtTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const hh = h % 12 || 12;
  return `${hh}${m ? `:${pad(m)}` : ""}${h >= 12 ? "pm" : "am"}`;
}
export const fmtRange = (ev) => (ev.start ? `${fmtTime(ev.start)}–${fmtTime(ev.end)}` : "All day");
export const fmtDate = (ds, opts = { weekday: "short", day: "numeric", month: "short" }) =>
  new Date(`${ds}T00:00:00`).toLocaleDateString("en-AU", opts);
